import { render, staticRenderFns } from "./epc-modal-wrapper.vue?vue&type=template&id=2b1707d5"
import script from "./epc-modal-wrapper.vue?vue&type=script&lang=js"
export * from "./epc-modal-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports